/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from "underscore";
import Link from '../LinkWithCountry/LinkWithCountry';
import * as userActions from '../../redux/actions/user';
import siteSetting from '../../shared/constants/siteSetting';
// REDUX

import styles from './Footer.module.css';
import './FooterBrandRefresh.module.css';

import { routeCountryPath } from '../../shared/utilities/common';
// eslint-disable-next-line import/no-cycle
import {renderSocialLinksSection} from "../../shared/utilities/renderings";
import amplitudeAnalytics, { AMPLITUDE_NAV_SECTION } from '../../shared/utilities/amplitude';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import {
  FOOTER_LINK_BR,
  FOOTER_LINK_LEGACY,
  getCopyrightClass,
  getDealsHeadingClass,
  getDealsSectionClass,
  getFooterContainerClass,
  getFooterWrapperClass,
  getGiftCardBodyClass,
  getGiftCardCtaClass,
  getGiftCardHeadingClass,
  getGiftCardLinkClass,
  getGiftCardSectionClass,
  getSignUpCtaClass,
  getSocialSectionClass,
} from './footerBrandRefreshClasses';

import endpoints from '../../shared/constants/endpoints';

import * as cms from "../../shared/repos/cms/cms";
import cmsKeys from "../../shared/constants/cms";
import CmsInlineEdit from '../Cms/CmsInlineEdit';

export const getYear = () => new Date().getFullYear();

export function FooterMobileStack({ brandRefresh, children }) {
  if (brandRefresh) {
    return <div data-part="footer-mobile-stack">{children}</div>;
  }
  return children;
}

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: []
    };
  }

  componentDidMount(){
    cms.getContent(cmsKeys.giftCardSection,this);
  }

  redirectToGiftCards = () => {
      window.location.href = endpoints.giftCardOrderPage;
  };

  footerContainer = () => {
    const {
      history,
      location,
      isCountrySelectActive,
      selectedCountry,
      facebookLink,
      instagramLink,
      tiktokLink,
      footerMenuItemsSettings,
      footerMenuItemsLinksSettings,
      isGiftcardDisabled
    } = this.props;
    const br = isBrandRefreshEnabled();
    const linkClass = br ? FOOTER_LINK_BR : FOOTER_LINK_LEGACY;
    const trackFooterNav = navElement => {
      amplitudeAnalytics.trackClickNavPrimary({
        navElement,
        navSection: AMPLITUDE_NAV_SECTION.FOOTER,
        pathname: location?.pathname,
      });
    };

    const renderLink = (link, text, attr = {}) => {
      const ariaLabel = text === 'FAQ' ? 'Frequently Asked Questions' : text;

      if (text === 'Donations') {
        return (
          <Link
            className={linkClass}
            to="/donations"
            aria-label={ariaLabel}
            onClick={() => trackFooterNav(text)}
          >
            {text}
          </Link>
        );
      }

      if (link.trim().indexOf('http') === 0) {
        return (
          <a
            href={link.trim()}
            target={attr.target || '_self'}
            rel={attr.rel || ''}
            className={linkClass}
            aria-label={ariaLabel}
            onClick={() => trackFooterNav(text)}
          >
            {text}
          </a>
        );
      }

      return (
        <Link
          className={linkClass}
          to={link}
          aria-label={ariaLabel}
          onClick={() => trackFooterNav(text)}
        >
          {text}
        </Link>
      );
    }
    const {content,loading} = this.state
    const giftCardSectionHeader = _.find(content, {key: cmsKeys.giftCardSection.giftCardSectionHeader });
    const giftCardSectionBody = _.find(content, {key: cmsKeys.giftCardSection.giftCardSectionBody });
    const giftCardSectionLinkText = _.find(content, {key: cmsKeys.giftCardSection.giftCardSectionLinkText });
    const giftCardSectionButtonText = _.find(content, {key: cmsKeys.giftCardSection.giftCardSectionButtonText });
    return (
      <div
        data-region={br ? 'site-footer' : undefined}
        className={getFooterWrapperClass(styles, br)}
      >
        {/* OPTIONS SECTION */}
        <div
          className={getFooterContainerClass(styles, br)}
        >
          <div
            className={`${styles.sectionContainer} col-span-2 flex flex-col gap-2 md:text-left text-center`}
          >
            <div
              data-part={br ? 'footer-nav-links' : undefined}
              className={`${styles.linksContainer} ${styles.desktopLinks} w-full md:grid grid-cols-2 gap-6`}
            >
              <div className="col-span-1">
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_NEWSROOM_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_NEWSROOM_LINK
                      ],
                      "Newsroom"
                    )
                  : null}
                {footerMenuItemsSettings[siteSetting.IS_FOOTER_MENU_FAQ_ENABLED]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_FAQ_LINK
                      ],
                      "FAQ"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_PRIVACY_POLICY_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_PRIVACY_POLICY_LINK
                      ],
                      "Privacy Policy"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_TERMS_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_TERMS_LINK
                      ],
                      "Terms & Conditions"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_EVENT_TERMS_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_EVENT_TERMS_LINK
                      ],
                      "Event Terms & Condition"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_ACCESSIBILITY_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_ACCESSIBILITY_LINK
                      ],
                      "Accessibility"
                    )
                  : null}
              </div>
              <div className="col-span-1">
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_CONTACT_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_CONTACT_LINK
                      ],
                      "Contact / FAQ"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_ALLERGEN_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_ALLERGEN_LINK
                      ],
                      "Allergen & Nutrition Info"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_ABOUT_US_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_ABOUT_US_LINK
                      ],
                      "About Us"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_CAREERS_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_CAREERS_LINK
                      ],
                      "Careers"
                    )
                  : null}
                {footerMenuItemsSettings[
                  siteSetting.IS_FOOTER_MENU_DONATIONS_ENABLED
                ]
                  ? renderLink(
                      footerMenuItemsLinksSettings[
                        siteSetting.FOOTER_MENU_DONATIONS_LINK
                      ],
                      "Donations"
                    )
                  : null}

                { footerMenuItemsSettings[siteSetting.IS_FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_ENABLED]
                    ? renderLink(
                      footerMenuItemsLinksSettings[siteSetting.FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_LINK],
                      'Promotions Terms & Conditions') : null }
                {isCountrySelectActive ? (
                  <Link
                    to="/countries"
                    title="Country Selection"
                    name="countries_link"
                    className={linkClass}
                    aria-label="Select your country"
                    onClick={() => {
                      trackFooterNav(
                        `Countries${
                          selectedCountry.short_name
                            ? ` (${selectedCountry.short_name})`
                            : ""
                        }`,
                      );
                    }}
                  >
                    Countries
                    {selectedCountry.short_name
                      ? ` (${selectedCountry.short_name})`
                      : ""}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <FooterMobileStack brandRefresh={br}>
            {/* NEVER MISS A DEAL SECTION */}
            <div
              data-part={br ? 'deals-section' : undefined}
              className={getDealsSectionClass(styles, br)}
            >
              <h3 className={getDealsHeadingClass(br)}>
              Never miss a deal
              </h3>
              <div className={styles.dealsContainer}>
                <span
                  data-part={br ? 'sign-up-cta' : undefined}
                  onClick={() => {
                  trackFooterNav("Sign me up!");
                  history.push(routeCountryPath("/create-account"));
                }}

                  tabIndex={0}
                  onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    trackFooterNav("Sign me up!");
                    history.push(routeCountryPath("/create-account"));
                  }
                }}
                  className={getSignUpCtaClass(styles, br)}
                  role='link'
                >
                Sign me up!
                </span>
              </div>
            </div>
            {/* GIFT CARD SECTION */}
            {Number(isGiftcardDisabled) === 1 && !loading ? null : (
              <div
                data-part={br ? 'gift-card-section' : undefined}
                className={getGiftCardSectionClass(styles, br)}
              >
                <h3 className={getGiftCardHeadingClass(br)}>
                  <CmsInlineEdit cmsNode={giftCardSectionHeader}>
                    {giftCardSectionHeader?.value}
                  </CmsInlineEdit>
                </h3>
                <p
                  data-part={br ? 'gift-card-body' : undefined}
                  className={getGiftCardBodyClass(br)}
                >
                  <CmsInlineEdit cmsNode={giftCardSectionBody}>
                    {giftCardSectionBody?.value?.replace(
                      /Visit a bakery today to buy a gift card or send e-gift card below\./g,
                      ''
                    ).trim()}
                  </CmsInlineEdit>
                  <CmsInlineEdit cmsNode={giftCardSectionLinkText} applyMarkdown={false} applyMarkdownOnEdit={false}>
                    <Link
                      data-part={br ? 'gift-card-link' : undefined}
                      to="/gift-card"
                      className={getGiftCardLinkClass(br)}
                      aria-label={giftCardSectionLinkText?.value}
                      onClick={() => {
                      trackFooterNav(
                        giftCardSectionLinkText?.value || "Gift card link",
                      );
                    }}
                    >
                      {giftCardSectionLinkText?.value}
                      {' '}
                    </Link>
                  </CmsInlineEdit>
                </p>
                <CmsInlineEdit cmsNode={giftCardSectionButtonText} applyMarkdown={false} applyMarkdownOnEdit={false}>
                  <span
                    data-part={br ? 'gift-card-cta' : undefined}
                    onClick={() => {
                    trackFooterNav(
                      giftCardSectionButtonText?.value || "Gift cards",
                    );
                    this.redirectToGiftCards();
                  }}
                    tabIndex={0}
                    onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      trackFooterNav(
                        giftCardSectionButtonText?.value || "Gift cards",
                      );
                      this.redirectToGiftCards();
                    }
                  }}
                    className={getGiftCardCtaClass(styles, br)}
                    role="link"
                  >
                    {giftCardSectionButtonText?.value}
                  </span>
                </CmsInlineEdit>
              </div>
          )}
            <div
              data-part={br ? 'mobile-footer-links' : undefined}
              className={`${styles.linksContainer} ${styles.mobileLinks}`}
            >
              <div>
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_NEWSROOM_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_NEWSROOM_LINK
                    ],
                    "Newsroom"
                  )
                : null}
                {footerMenuItemsSettings[siteSetting.IS_FOOTER_MENU_FAQ_ENABLED]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_FAQ_LINK
                    ],
                    "FAQ"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_PRIVACY_POLICY_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_PRIVACY_POLICY_LINK
                    ],
                    "Privacy Policy"
                  )
                : null}
                {footerMenuItemsSettings[siteSetting.IS_FOOTER_MENU_TERMS_ENABLED]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_TERMS_LINK
                    ],
                    "Terms & Conditions"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_EVENT_TERMS_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_EVENT_TERMS_LINK
                    ],
                    "Event Terms & Condition"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_ACCESSIBILITY_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_ACCESSIBILITY_LINK
                    ],
                    "Accessibility"
                  )
                : null}
              </div>
              <div>
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_CONTACT_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_CONTACT_LINK
                    ],
                    "Contact / FAQ"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_ALLERGEN_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_ALLERGEN_LINK
                    ],
                    "Allergen & Nutrition Info"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_ABOUT_US_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_ABOUT_US_LINK
                    ],
                    "About Us"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_CAREERS_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_CAREERS_LINK
                    ],
                    "Careers"
                  )
                : null}
                {footerMenuItemsSettings[
                siteSetting.IS_FOOTER_MENU_DONATIONS_ENABLED
              ]
                ? renderLink(
                    footerMenuItemsLinksSettings[
                      siteSetting.FOOTER_MENU_DONATIONS_LINK
                    ],
                    "Donations"
                  )
                : null}
                { footerMenuItemsSettings[siteSetting.IS_FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_ENABLED]
                ? renderLink(footerMenuItemsLinksSettings[siteSetting.FOOTER_MENU_PROMOTIONS_TERMS_AND_CONDITIONS_LINK], 'Promotions Terms & Conditions') : null }
              </div>
            </div>
            {/* SOCIAL SECTION */}
            <div
              data-part={br ? 'social-links' : undefined}
              className={getSocialSectionClass()}
            >
              {renderSocialLinksSection(styles.socialContainer, {
              facebookLink,
              instagramLink,
              tiktokLink,
              accessibility:true,
              cookiesConsent: true,
              brandRefresh: br,
            })}
            </div>
          </FooterMobileStack>
        </div>
        <div
          data-part={br ? 'recap-notice' : undefined}
          className={`${styles.recapv3} w-full text-center md:text-left`}
        >
          <span>This site is protected by reCAPTCHA and the Google</span>
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer"> Privacy Policy </a>
          <span>and</span>
          <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer"> Terms of Service </a>
          <span>apply.</span>
        </div>
        <span
          data-part={br ? 'copyright' : undefined}
          className={getCopyrightClass(styles, br)}
        >
          {`insomnia cookies warm.delicious.delivered. © ${getYear()}`}
        </span>
      </div>
    );
  };

  render() {
    return <this.footerContainer />;
  }
}

export const mapStateToProps = (state) => {
  const { endpoint } = state.user;
  const { isCountrySelectActive, selectedCountry } = state.country;
  const { tiktokLink, instagramLink, facebookLink, footerMenuItemsSettings, footerMenuItemsLinksSettings } = state.footerSettings;
  const { isGiftcardDisabled } = state.giftCard;

  return {
    endpoint,
    isCountrySelectActive,
    selectedCountry,
    tiktokLink,
    instagramLink,
    facebookLink,
    footerMenuItemsSettings,
    footerMenuItemsLinksSettings,
    isGiftcardDisabled
  };
};

export const mapDispatchToProps = (dispatch) => ({
  setEndpoint: (value) => dispatch(userActions.setEndpoint(value)),
  setUserAddress: (value) => dispatch(userActions.setUserAddress(value))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));
